import { useEffect, useState } from "react";
import { Loader2, Smartphone, Monitor } from "lucide-react";
import { api, errorMessage } from "../api";
import { fmtDT } from "../lib/units";

const FIELDS = [
  ["android_play_url", "Google Play link", "https://play.google.com/store/apps/details?id=in.fyndine.app"],
  ["android_apk_url", "Android APK download link", "https://…/FynDine.apk"],
  ["android_version", "Android version", "1.0.0"],
  ["windows_exe_url", "Windows installer (.exe) link", "https://…/FynDine-Setup.exe"],
  ["windows_version", "Windows version", "1.0.0"],
];

function GithubSync({ onDone }) {
  const [repo, setRepo] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  useEffect(() => { api.get("/public/app-downloads").then(({ data }) => data.github_repo && setRepo(data.github_repo)).catch(() => {}); }, []);
  const go = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try { onDone((await api.post("/admin/app-downloads/from-github", { repo })).data); } catch (x) { setErr(errorMessage(x)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={go} className="admin-form-grid" style={{ marginTop: 16 }} data-testid="app-dl-github">
      <label style={{ gridColumn: "1 / -1" }}>GitHub repository (after the "Build FynDine apps" workflow finishes)<input required placeholder="your-org/fyndine" value={repo} onChange={(e) => setRepo(e.target.value)} data-testid="app-dl-github-repo" /></label>
      <div style={{ gridColumn: "1 / -1" }}><button className="secondary-button" disabled={busy} data-testid="app-dl-github-sync">{busy ? <Loader2 className="spin" size={14} /> : null} Fetch latest release</button></div>
      {err && <div className="auth-alert error" style={{ gridColumn: "1 / -1" }} data-testid="app-dl-github-error">{err}</div>}
    </form>
  );
}

export default function AppDownloadsAdmin() {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(""); const [err, setErr] = useState("");
  useEffect(() => { api.get("/public/app-downloads").then((r) => setF((cur) => cur || r.data)).catch((e) => setErr(errorMessage(e))); }, []);
  const save = async (e) => {
    e.preventDefault(); setBusy(true); setErr(""); setMsg("");
    try { setF((await api.put("/admin/app-downloads", f)).data); setMsg("Download links updated — the /download page shows them now."); }
    catch (x) { setErr(errorMessage(x)); } finally { setBusy(false); }
  };
  if (!f) return <div className="admin-form-card">{err || <Loader2 className="spin" size={18} />}</div>;
  return (
    <section className="admin-form-card" data-testid="app-downloads-admin">
      <h2><Smartphone size={18} /> <Monitor size={18} /> Desktop & mobile apps</h2>
      <p className="form-hint">Paste the links after each Android or Windows release. Empty links show "Coming soon" on the public download page.{f.updated_at ? ` Last updated ${fmtDT(f.updated_at)}.` : ""}</p>
      <form onSubmit={save} className="admin-form-grid">
        {FIELDS.map(([k, label, ph]) => <label key={k}>{label}<input value={f[k] || ""} placeholder={ph} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`app-dl-${k}`} /></label>)}
        <label style={{ gridColumn: "1 / -1" }}>Release notes<textarea rows={3} value={f.release_notes || ""} onChange={(e) => setF({ ...f, release_notes: e.target.value })} data-testid="app-dl-release_notes" /></label>
        <div style={{ gridColumn: "1 / -1" }}><button className="primary-button" disabled={busy} data-testid="app-dl-save">{busy ? <Loader2 className="spin" size={14} /> : null} Save links</button></div>
      </form>
      {msg && <div className="auth-alert info" data-testid="app-dl-message">{msg}</div>}
      <GithubSync onDone={(d) => { setF(d); setMsg("Links filled from the latest GitHub release — the /download page shows them now."); }} />
      {err && <div className="auth-alert error" data-testid="app-dl-error">{err}</div>}
    </section>
  );
}
